import './_news-archive-page.scss';

(function newsArchivePage() {
  const newsListPageComponent = document.querySelector('[data-component="news-archive-page"]') as HTMLElement | null;
  if (newsListPageComponent) {
    class NewsArchivePage {
      private isLoading = false;

      public init() {
        this.setUpMoreResults();
      }

      private setUpMoreResults(): void {
        this.isLoading = false;

        let currentPage = 1;
        const moreResults = document.getElementById('more-results');
        const container = document.getElementById('news-list');
        const url = moreResults?.getAttribute('data-more');
        const dataPages = newsListPageComponent?.getAttribute('data-pages');
        const pages = dataPages ? parseInt(dataPages, 10) : 0;

        if (currentPage === pages) {
          newsListPageComponent?.classList.add('bottom');
          if (moreResults) {
            this.hideBlock(moreResults);
          }
          container?.removeAttribute('aria-busy');
          container?.removeAttribute('aria-live');
          container?.removeAttribute('aria-relevant');
        } else {
          moreResults?.addEventListener('click', (e) => {
            e.preventDefault();
            if (currentPage < pages && !this.isLoading) {
              container?.setAttribute('aria-busy', 'true');
              currentPage += 1;
              this.isLoading = true;
              container?.classList.add('news-list__loading');
              fetch(`${url}?p=${currentPage}`)
                .then((response) => response.text())
                .then((data) => {
                  this.isLoading = false;
                  container?.classList.remove('news-list__loading');
                  container?.insertAdjacentHTML('beforeend', data);
                  if (currentPage === pages) {
                    newsListPageComponent?.classList.add('bottom');
                    this.hideBlock(moreResults);
                  }
                  container?.setAttribute('aria-busy', 'false');
                })
            }
          });
        }
      }

      private hideBlock(element?: HTMLElement) {
        element?.classList.add('d-none');
        element?.classList.remove('d-block');
      }
    }
    const page = new NewsArchivePage();
    page.init();
  }
})();
